var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoresults(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 121,
    viewBox: "0 0 136 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4469 95.2151C69.067 95.2151 69.5696 94.7123 69.5696 94.0924C69.5696 93.4726 69.067 92.9697 68.4469 92.9697C67.8268 92.9697 67.3242 93.4726 67.3242 94.0924C67.3242 94.7123 67.8268 95.2151 68.4469 95.2151Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8301 10.6885V15.6148",
    stroke: "#BABABA",
    strokeWidth: 5.3156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3555 13.1514H38.2933",
    stroke: "#BABABA",
    strokeWidth: 5.3156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9109 41.7583C82.3218 41.7583 72.5607 41.3689 63.4297 38.8254C54.4706 36.3393 46.2449 31.5161 38.9126 25.9367C34.1123 22.305 29.7474 19.4064 23.5149 19.8417C17.4178 20.1717 11.5873 22.4484 6.87988 26.3376C-1.04817 33.2802 0.143494 46.1461 3.31696 55.1509C8.08297 68.75 22.5871 78.2245 34.9143 84.3537C49.1548 91.4683 64.8046 95.6041 80.4887 97.9756C94.2367 100.072 111.903 101.584 123.818 92.6139C134.759 84.3537 137.76 65.519 135.079 52.8023C134.429 49.0456 132.428 45.6557 129.454 43.2705C121.767 37.6454 110.299 41.4031 101.661 41.5863C98.4527 41.6553 95.1876 41.7355 91.9109 41.7583Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4 3.97439C77.0201 3.97439 77.5227 3.47178 77.5227 2.8517C77.5227 2.23162 77.0201 1.729 76.4 1.729C75.78 1.729 75.2773 2.23162 75.2773 2.8517C75.2771 3.47178 75.78 3.97439 76.4 3.97439Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 91.3999V96.3263",
    stroke: "#BABABA",
    strokeWidth: 5.3156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5977 93.8628H20.524",
    stroke: "#BABABA",
    strokeWidth: 5.3156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9068 120.27C92.1338 120.27 110.964 119.096 110.964 117.647C110.964 116.197 92.134 115.023 68.9068 115.023C45.6792 115.023 26.8496 116.197 26.8496 117.647C26.8496 119.096 45.6792 120.27 68.9068 120.27Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.714 89.5436H30.0673C29.5813 89.5436 29.1009 89.4371 28.6597 89.2332C28.2185 89.0293 27.8269 88.7315 27.512 88.3614C27.1971 87.9902 26.9665 87.5559 26.8361 87.0874C26.7057 86.6188 26.6783 86.1283 26.7563 85.6485L36.0476 29.3049C36.1733 28.5208 36.5746 27.807 37.1794 27.2925C37.7843 26.7778 38.5529 26.4961 39.3472 26.4981H111.993C112.479 26.4981 112.959 26.6039 113.4 26.8082C113.84 27.0125 114.232 27.3104 114.546 27.6811C114.86 28.0518 115.089 28.4863 115.219 28.9547C115.347 29.4232 115.373 29.914 115.293 30.3931L106.048 86.7367C105.92 87.526 105.513 88.2422 104.901 88.7577C104.289 89.272 103.513 89.5515 102.714 89.5436Z",
    fill: "#D2D2D2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M103.61 25.0249L60.4889 5.77185C59.2177 5.20436 57.7273 5.77465 57.1598 7.04584L43.493 37.6554C42.9256 38.9266 43.4958 40.417 44.7668 40.9845L87.8877 60.2373C89.1593 60.8048 90.6499 60.2345 91.217 58.9635L104.883 28.354C105.452 27.0828 104.882 25.5924 103.61 25.0249Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 5.3156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8105 30.955C67.9455 29.3622 69.5963 28.2111 71.483 27.6964C73.3698 27.1817 75.3764 27.335 77.1631 28.1305C78.9496 28.926 80.4062 30.3149 81.2862 32.0615C82.166 33.8082 82.4147 35.8053 81.9905 37.7144",
    stroke: "#BABABA",
    strokeWidth: 3.6146,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.432 29.2248C88.084 29.2248 88.612 28.6963 88.612 28.0448C88.612 27.393 88.0837 26.8647 87.432 26.8647C86.7802 26.8647 86.252 27.393 86.252 28.0448C86.252 28.6965 86.7802 29.2248 87.432 29.2248Z",
    fill: "#BABABA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3382 21.5949C70.9898 21.5949 71.5183 21.0667 71.5183 20.4149C71.5183 19.7633 70.9898 19.2349 70.3382 19.2349C69.6865 19.2349 69.1582 19.7633 69.1582 20.4149C69.1582 21.0667 69.6865 21.5949 70.3382 21.5949Z",
    fill: "#BABABA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.393 89.5209H29.3911C28.5029 89.5175 27.652 89.1623 27.025 88.5334C26.3978 87.9045 26.0459 87.052 26.0459 86.1641V34.6895C26.0353 34.2429 26.1138 33.7987 26.2769 33.383C26.4401 32.967 26.6847 32.5881 26.9964 32.2678C27.3078 31.9477 27.6802 31.693 28.0915 31.5186C28.5027 31.3443 28.9445 31.2537 29.3913 31.2524H55.9821C56.5992 31.2548 57.2035 31.427 57.7292 31.7503C58.2547 32.0738 58.681 32.5357 58.9609 33.0855L62.753 40.5094C63.0321 41.0601 63.458 41.5229 63.9839 41.8462C64.5095 42.1697 65.1145 42.3415 65.7318 42.3425H102.393C103.279 42.3425 104.131 42.6949 104.758 43.3223C105.385 43.9497 105.738 44.8006 105.738 45.688V86.1641C105.738 87.052 105.386 87.9043 104.758 88.5334C104.132 89.1623 103.28 89.5175 102.393 89.5209Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 5.3156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1564 44.0957C86.9391 44.0933 82.8158 45.3419 79.308 47.6834C75.8003 50.0247 73.0658 53.3538 71.4504 57.2495C69.8351 61.1452 69.4111 65.4323 70.2325 69.569C71.0539 73.7054 73.0835 77.5056 76.0647 80.4886C79.0462 83.4715 82.8449 85.5033 86.9815 86.3273C91.1173 87.151 95.4044 86.7295 99.3008 85.1156C103.198 83.5023 106.529 80.7694 108.872 77.2632C111.214 73.7569 112.466 69.6341 112.466 65.4168C112.466 59.7641 110.221 54.3429 106.225 50.3448C102.229 46.3463 96.8091 44.0987 91.1564 44.0957Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 5.3156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.322 80.8828L112.005 86.5653",
    stroke: "#BABABA",
    strokeWidth: 5.3156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.365 83.8039L109.6 85.6507C108.809 86.479 108.838 87.7907 109.666 88.5824L124.987 103.229C125.814 104.02 127.127 103.99 127.918 103.162L129.684 101.315C130.475 100.488 130.446 99.1752 129.617 98.3836L114.297 83.7381C113.469 82.9463 112.156 82.976 111.365 83.8039Z",
    fill: "#D2D2D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.705 2.85205V7.78984",
    stroke: "#BABABA",
    strokeWidth: 5.3156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M120.23 5.32617H125.168",
    stroke: "#BABABA",
    strokeWidth: 5.3156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoresults);
export default __webpack_public_path__ + "static/media/noresults.add0fa57029562ce38fa16a2d4e0c378.svg";
export { ForwardRef as ReactComponent };